import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { notificationsApi as n } from "@maat/api-notifications";
//#region src/notifications/useNotificationPreferenceGroupsQuery.ts
var r = () => t({
	queryKey: e.preferenceGroups(),
	queryFn: () => n.getNotificationPreferenceGroups(),
	select: (e) => e.groups
});
//#endregion
export { r as useNotificationPreferenceGroupsQuery };
